import React from 'react';
import DeviceSelection from '../../../DeviceSelection';
import MicrophoneIcon from '../../../common/Icons/Microphone';
import { useTwilioUserMediaContext } from '../../../../customer-call-sdk';
import Messages from '../../../../config/messages.constants';

const defaultMicrophone: MediaDeviceInfo = {
    deviceId: 'default',
    kind: 'audiooutput',
    label: 'No Microphone available',
    groupId: '',
    toJSON: () => {},
};
/**
 * Camera selection list item
 */
const MicrophoneSelection: React.FC = () => {
    const {
        microphones,
        audioDeviceId,
        isAudioBlocked,
        isRequestingAudioPermission,
        startMedia,
    } = useTwilioUserMediaContext();
    const selectedMicrophone =
        microphones.find((microphone) => microphone.deviceId === audioDeviceId) || null;
    const microphoneUnavailable = microphones.length === 0;

    /**
     * Handle select change
     *
     * @param {MediaDeviceInfo} value selected camera
     */
    const handleChange = (value: MediaDeviceInfo) => {
        startMedia({ audioDeviceId: value.deviceId, type: 'exact' });
    };

    return (
       
        <DeviceSelection
            icon={MicrophoneIcon}
            primaryText={Messages.DEVICE_SETTING.MICROPHONE.TITLE}
            value={microphoneUnavailable ? defaultMicrophone : selectedMicrophone}
            options={microphoneUnavailable ? [defaultMicrophone] : microphones}
            onChange={handleChange}
            disabled={isAudioBlocked || isRequestingAudioPermission || microphoneUnavailable}
            data-testid="camera-device-setting"
            id="camera-device-setting"
            ariaLabel="Microphone options"
        />
    );
};

export default MicrophoneSelection;
